import { useEffect } from 'react';
import toast from 'react-hot-toast';

import { limiteCaracteres } from '../../config/limiteCaracteres';

import menosIcon from '../../imagens/minus.png'
import maisIcon from '../../imagens/plus-sign.png'

function AssinaturasFormularioAcompanhamento({ assinaturas, setAssinaturas, limitMax, limitMin }) {

    const assinatura = { 'nomeCompleto': null, 'matricula': null, 'setor': null }

    useEffect(() => {
        if (!assinaturas) {
            setAssinaturas([assinatura]);
        }
    }, []);

    const atualizaAssinatura = (index, key, value) => {
        setAssinaturas(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, [key]: value }
                    : item
            )
        );
    };

    const addAssinatura = () => {
        setAssinaturas(prev => {
            if (prev.length >= limitMax) {
                toast.error(`Você atingiu o limite de ${limitMax} assinaturas`);
                return prev;
            }
            return [...prev, { ...assinatura }];
        });
    };

    const delAssinatura = (index) => {
        setAssinaturas(prev => {
            if (prev.length <= limitMin) {
                toast.error(`Você deve manter pelo menos ${limitMin} assinatura`);
                return prev;
            }
            return prev.filter((_, i) => i !== index);
        });
    };

    return (
        <div className='table-responsive-sm col-12 col-md-6'>
            {assinaturas && (
                <table className='table table-responsive table-borderless'>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope='col'>Nome Completo</th>
                            <th scope='col'>Matrícula</th>
                            <th scope='col'>Setor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assinaturas.map((assinatura, index) => (
                            <tr key={index}>
                                <th scope="row">{index + 1}</th>
                                <td>
                                    <input
                                        className='form-control form-control-sm'
                                        onBlur={(e) => atualizaAssinatura(index, 'nomeCompleto', e.target.value)}
                                        maxLength={limiteCaracteres.RELAT_ACOMP_ASSINATURA}
                                        required
                                    >
                                    </input>
                                </td>
                                <td>
                                    <input
                                        className='form-control form-control-sm'
                                        onBlur={(e) => atualizaAssinatura(index, 'matricula', e.target.value)}
                                        maxLength={limiteCaracteres.RELAT_ACOMP_ASSINATURA}
                                        required
                                    >
                                    </input>
                                </td>
                                <td>
                                    <input
                                        className='form-control form-control-sm'
                                        onBlur={(e) => atualizaAssinatura(index, 'setor', e.target.value)}
                                        maxLength={limiteCaracteres.RELAT_ACOMP_ASSINATURA}
                                        required
                                    >
                                    </input>
                                </td>
                                <td>
                                    <div className='d-flex gap-2'>
                                        <img
                                            className='minusAndPlusIcon'
                                            alt='Ícone adiciona assinatura'
                                            src={maisIcon}
                                            onClick={addAssinatura}
                                            style={{ width: '25px', height: '25px' }}
                                        />
                                        <img
                                            className='minusAndPlusIcon'
                                            alt='Ícone remove assinatura'
                                            src={menosIcon}
                                            onClick={() => delAssinatura(index)}
                                            style={{ width: '25px', height: '25px' }}
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default AssinaturasFormularioAcompanhamento;
